import {
  getLowestPlanNameWithFeatureAccess,
  type PlanFeatureName,
} from "@repo/app-types/helpers/billingFeatureGating";
import { Button, ButtonVariant } from "@repo/ui/Buttons/button";
import { InfoBanner } from "@repo/ui/InfoBanner/infoBanner";
import type { FC } from "react";

interface UpsellBannerProps {
  planFeatureName: PlanFeatureName;
}

export const UpsellBanner: FC<UpsellBannerProps> = ({ planFeatureName }) => {
  const planToUpgradeTo = getLowestPlanNameWithFeatureAccess(planFeatureName);

  return (
    <InfoBanner
      title={`Upgrade to ${planToUpgradeTo} to access this feature`}
      variant="UPSELL"
      description={
        <>
          {
            "Want to upgrade or need help deciding what plan is best for your team?"
          }
          <div className="mt-4 flex space-x-4">
            <Button
              variant={ButtonVariant.Primary}
              onClick={() => {
                window.open("mailto:support@alpharun.com");
              }}
            >
              Contact us
            </Button>
            <Button
              variant={ButtonVariant.Secondary}
              onClick={() => {
                window.open("https://cal.frontapp.com/alpharun/paul/7fc09a3a");
              }}
            >
              Book a meeting
            </Button>
          </div>
        </>
      }
    />
  );
};
